
export class DeviceInfo {

  public id?: number;
  public value?: any;
  public start?: string;
  public end?: string;

  public device?: any;
  public attribute?: any;
  public deviceName?: string;
  public attributeName?: string;
  public config?: any;

  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.value = data.value;
      this.start = data.start;
      this.end = data.end;
      this.device = data.device;
      this.deviceName = data.deviceName;
      this.attributeName = data.attributeName;
      this.config = data.config;
      this.attribute = data.attribute;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
    }
  }

  public isValid() {
    return !!this.value && !!this.attribute
  }
}
